const tabs = (tabsParentSelector) => {
    const tabsBlock = document.querySelector(tabsParentSelector);
    let tabsHdrItem, tabsContentItem;

    if(tabsBlock) {
        tabsHdrItem = tabsBlock.querySelectorAll('.item');
        tabsContentItem = tabsBlock.querySelectorAll('.content-item');
    }

    try {    
        tabsBlock.addEventListener('click', (e) => {
            let target = e.target;

            if(target.classList.contains('item')) {
                tabsHdrItem.forEach(item => {
                    item.classList.remove('active');
                });

                target.classList.add('active');

                tabsContentItem.forEach(item => {
                    if(target.dataset.tabHdr == item.dataset.tabContent) {
                        item.classList.remove('hidden'); 
                    } else {
                        item.classList.add('hidden'); 
                    }
                });
            }
        });
    } catch(e){}
};

export default tabs;